/* eslint-disable import/extensions */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/first */
/* eslint-disable import/no-webpack-loader-syntax */
import { requirejs, require, define, originalRequire } from './globals';
import 'imports-loader?additionalCode=var%20require%20%3D%20window.require%3B!js/require.config';
import initBaseConfig from './require-base-config';

const init = () => {
  initBaseConfig(require);
};

export { requirejs as default, requirejs, require, define, originalRequire, init };
